module.exports = __webpack_public_path__ + "img/ASSCHER.a4b5a6cb.png";